module.exports = __webpack_public_path__ + "static/media/media-folder-shared.b510f6fb.svg";